import { formatAddendumAddedAt, getNoteAddendums } from '../utils/addendum';
import { formatCareTimeLabel } from '../utils/lateEntry';
import { useLanguage } from '../contexts/LanguageContext';

export default function NoteAddendumsList({ note }) {
  const { t, language } = useLanguage();
  const addendums = getNoteAddendums(note);
  if (!addendums.length) return null;

  return (
    <div className="mt-4 space-y-3">
      {addendums.map((item) => (
        <div
          key={item.id}
          className="rounded-xl border border-gray-200 bg-gray-100 p-3"
        >
          <p className="text-xs font-semibold text-gray-600">
            {t('addendumAddedAt', {
              time: formatAddendumAddedAt(item.addendum_time, language),
            })}
          </p>
          {item.addendum_care_time ? (
            <p className="mt-0.5 text-xs text-gray-500">
              {t('timeOfCare')}:{' '}
              {formatCareTimeLabel(item.addendum_care_time, item.care_day_offset || 0, language)}
            </p>
          ) : null}
          <p className="mt-2 whitespace-pre-wrap text-sm text-gray-800">
            {item.addendum_text}
          </p>
        </div>
      ))}
    </div>
  );
}
